import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useTokenAndOrgId, InferenceAPI } from './utils'
import { CreateDockerCredArgs } from './inference.gen'
import { toast } from 'react-hot-toast'

export const useListDockerCreds = () => {
  const { token, orgId } = useTokenAndOrgId()
  return useQuery({
    queryKey: ['docker-creds', token, orgId],
    queryFn: () =>
      InferenceAPI.listDockerCreds({ page_size: 100, page_number: 1 }),
    enabled: !!token && !!orgId,
    select: (data) => data.creds,
  })
}

export const useCreateDockerCred = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (args: CreateDockerCredArgs) =>
      InferenceAPI.createDockerCred(args),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['docker-creds'] })
      toast.success('Docker credential created')
    },
    onError: (error) => toast.error(JSON.stringify(error)),
  })
}

export const useDeleteDockerCred = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => InferenceAPI.deleteDockerCred({ id }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['docker-creds'] })
      toast.success('Docker credential deleted')
    },
    onError: (error) => toast.error(JSON.stringify(error)),
  })
}
